import axiosConfig from "../../../utils/axiosConfig";

const BASE_PATH = "pages/memberships/active_packages";

const activePackagesApi = (module) => {
  const baseUrl = `${BASE_PATH}/${module}`;

  return {
    getData(params) {
      return axiosConfig.get(`${baseUrl}`, { params });
    }
  };
};

export const api = {
  trend: activePackagesApi("trends"),
  details: activePackagesApi("details")
};
